import { render, staticRenderFns } from "./PropertyDetailsForm.vue?vue&type=template&id=338dee1e&scoped=true&"
import script from "./PropertyDetailsForm.vue?vue&type=script&lang=js&"
export * from "./PropertyDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDetailsForm.vue?vue&type=style&index=0&id=338dee1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338dee1e",
  null
  
)

export default component.exports